export default __webpack_public_path__ + "static/media/Label_printed.38109aff.png";